<template>
    <div class="wrapper">
      <Dialog :visible.sync="display" :modal="true" :closable="false">
        <template #header>
          <h3>Du är utloggad</h3>
        </template>
        <div class="loginFormWrapper">
              <form @submit.prevent="login">
                <div class="form-group">
                  <input type="text" v-model="user.email" name="username"
                    placeholder="Användarnamn"
                    class="form-control"
                    required>
                  <div class="invalid-feedback" style="display: none;">
                    Användarnamn är obligatoriskt</div>
                  </div>
                <div class="form-group">
                  <input type="password" v-model="user.password"
                    name="password"
                    placeholder="Lösenord"
                    class="form-control"
                    required>
                  <div class="invalid-feedback" style="display: none;">Lösenord är obligatoriskt</div>
                </div>
                <div class="form-group formLoginButtons">
                  <button class="btn btn-primary">Logga in</button>
                  <!-- <button class="btn btn-primary forgotPasswordBtn">Glömt lösenord?</button> -->
                </div>
                <div v-if="inValidError !=''" class="onErrorValidationWrapper">
                    <p class="text-danger">{{inValidError}}</p>
                </div>
              </form>
            </div>
      </Dialog>
    </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { bus } from '@/main'
export default {
  components: {
    Dialog,
    Button
  },
  data () {
    return {
      inValidError: '',
      user: {
        email: '',
        password: ''
      },
      display: false
    }
  },
  created () {
    if (this.$route.name !== 'Login') {
      let that = this
      this.timer = setInterval(function () {
        const token = localStorage.getItem('token') || ''
        const decodedToken = that.$jwtDec.decode(token)
        if ((Date.now() / 1000) > decodedToken.exp) {
          that.display = true
        } else {
          that.display = false
        }
      },
      10000)
    }
  },
  methods: {
    login: function () {
      let email = this.user.email
      let password = this.user.password
      this.$store.dispatch('login', { email, password })
        .then(() => {
          this.display = false
          bus.$emit('loggedIn', true)
        })
        .catch(err => {
          console.log(err)
          this.inValidError = 'Felaktigt namn eller lösenord'
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/LoginModal.vue